"use strict";
import ObjectWithIDStore from "../stores/object_with_id_store";
var ToBeScrapedLoadService = function() {
  return {
    store: new ObjectWithIDStore(),
    update: function() {
      var service = this;
      return $.get("/api/to_be_scraped_loads").then(function(data) {
        _.each(data.to_be_scraped_loads, function(to_be_scraped_load) {
          service.store.addOrUpdate(to_be_scraped_load);
        });
        return data;
      });
    },
    toBeScrapedLoads: function() {
      return _.sortBy(this.store.items, _.property("id"));
    },
    filtered: function(filters) {
      var service = this;
      var ret = $.get(
        "/api/to_be_scraped_loads",
        filters
      ).then(function(data) {
        _.each(data.to_be_scraped_loads, function(to_be_scraped_load) {
          service.store.addOrUpdate(to_be_scraped_load);
        });
        return $.Deferred().resolve(data);
      });
      return ret;
    }
  };
};
var toBeScrapedLoadService = new ToBeScrapedLoadService();
export default toBeScrapedLoadService;
